module.exports = __webpack_public_path__ + "static/img/logo_temp.1fbe503b.jpg";